// extracted by mini-css-extract-plugin
export default {"transferPill":"TransactionsTableRow_transferPill__5FFfz","transferArrows":"TransactionsTableRow_transferArrows__cFHxg"};